import {EntityService} from '../../../service/EntityService';

export class PaymentTypeService extends EntityService {

  static entity = 'app/payment-type';

  static deleteMulti(ids: Array<string>): Promise<any> {
    return this.axios.post(`${this.entity}/multi-delete`, ids).then(res => res.data);
  }

}
